import ReactGA from 'react-ga4';
import { defaultConfig } from '../../../config-env';

export const GA_CATEGORIES = Object.freeze({
  files: 'files',
  user: 'user',
});

export const GA_ACTIONS = Object.freeze({
  publish: 'publish',
  fileUpload: 'file_upload',
});

export const GA_LABELS = Object.freeze({
    channels: 'channels',
    guestRequest: 'guest request',
    ird: 'ird',
  });

export const initGA = () => {
  ReactGA.initialize(defaultConfig.googleAnalyticsId);
};

export const visitPageGA =
  ({ page, key }) =>
  (_, getState) => {
    const {
      user: { user },
    } = getState();

    ReactGA.send({
      hitType: 'pageview',
      page,
      key,
      user: user.email,
    });
  };

export const sendEventGA = ({ category = GA_CATEGORIES.user, action, label = '', value = 0 }) => {
  ReactGA.event({
    category,
    action,
    label, // optional
    value, // optional, must be a number
    nonInteraction: true, // optional, true/false
    transport: 'xhr', // optional, beacon/xhr/image
  });
};
